import { AscType, SortType } from 'commons/constants/type';
import KeyFlowParamVO from 'commons/vo/param/KeyFlowParamVO';
import { SearchCondition, SearchType } from 'commons/constants/KeyFlowConstants';

export type WkblVideoParamVOProps = {
  searchType: string;
  season?: string;
  gameTypes?: number[];
  subTypes?: string[];
  teamId?: number;
  title?: string;
  gameDateFrom?: string;
  gameDateTo?: string;
  keywords?: string[];

  retr?: number;
  page?: number;
  asc?: AscType;
  sort?: SortType;
};

class WkblVideoParamVO extends KeyFlowParamVO {
  searchType: string;
  season?: string;
  gameTypes?: number[];
  subTypes?: string[];
  // videoType?: string;
  teamId?: number;
  title?: string;
  gameDateFrom?: string;
  gameDateTo?: string;
  retr?: number;
  page?: number;
  asc?: AscType;
  sort?: SortType;
  keywords?: string[];

  constructor(data: WkblVideoParamVOProps) {
    super();
    this.searchType = data.searchType;
    this.season = data.season;
    this.gameTypes = data.gameTypes;
    this.subTypes = data.subTypes;
    // this.videoType = data.videoType;
    this.teamId = data.teamId;
    this.title = data.title;
    this.gameDateFrom = data.gameDateFrom;
    this.gameDateTo = data.gameDateTo;
    this.keywords = data.keywords;

    this.retr = data.retr || 10;
    this.page = data.page || 0;
    this.sort = data.sort || SearchCondition.Sort.DATE_OF_CREATED;
    this.asc = data.asc || SearchCondition.Asc.DESC;
  }
}

export default WkblVideoParamVO;
